(function () {
  'use strict';

  var screen    = document.getElementById('isladerm-loading-screen');
  if (!screen) return;

  if (sessionStorage.getItem('isladerm_ls_shown')) {
  screen.classList.add('ls-hidden');
  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
  return;
}
sessionStorage.setItem('isladerm_ls_shown', '1');

  var progressBar  = screen.querySelector('.ls-progress__bar');
  var progressWrap = screen.querySelector('.ls-progress');
  var scrollHint   = screen.querySelector('.ls-scroll-hint');

  var isRevealed = false;
  var isLoaded   = false;

  /* ── Simulated progress fill ─────────────────────────────── */
  var progress = 5;
  var progressTimer = setInterval(function () {
    // Ease toward 88% while the page is still loading
    var step = (88 - progress) * 0.12;
    progress = Math.min(progress + step, 88);
    if (progressBar) progressBar.style.width = progress + '%';
  }, 120);

  /* ── On window load ─────────────────────────────────────── */
  window.addEventListener('load', function () {
    clearInterval(progressTimer);
    isLoaded = true;

    // Snap to 100 %
    if (progressBar) {
      progressBar.style.transition = 'width 0.35s ease';
      progressBar.style.width = '100%';
    }

    // Fade out the bar, then show scroll hint
    setTimeout(function () {
      if (progressWrap) progressWrap.classList.add('ls-fade-out');
    }, 400);

    setTimeout(function () {
      if (scrollHint) scrollHint.classList.add('ls-visible');
    }, 900);

    // Safety auto-dismiss: if the user hasn't scrolled after 6 s, slide it away
    setTimeout(function () {
      if (!isRevealed) reveal();
    }, 6000);
  });

  /* ── Reveal (slide up and remove) ───────────────────────── */
  function reveal() {
    if (isRevealed) return;
    isRevealed = true;

    // Restore scrolling
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';

    screen.classList.add('ls-slide-up');

    screen.addEventListener('transitionend', function handler() {
      screen.removeEventListener('transitionend', handler);
      screen.classList.add('ls-hidden');
    });
  }

  /* ── Lock scroll while loading screen is active ─────────── */
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow             = 'hidden';

  /* ── Trigger reveal on first user gesture after load ─────── */
  function onScroll() {
    if (!isLoaded) return;   // ignore accidental events before load
    reveal();
  }

  window.addEventListener('wheel',     onScroll, { passive: true });
  window.addEventListener('touchmove', onScroll, { passive: true });
  window.addEventListener('keydown', function (e) {
    var keys = ['ArrowDown', ' ', 'PageDown', 'End'];
    if (keys.indexOf(e.key) !== -1 && isLoaded) reveal();
  });
})();
